import type { IconData } from '@stacksjs/iconify-core'

export const horizontalMenuCircleSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5 24C1.5 11.574 11.574 1.5 24 1.5S46.5 11.574 46.5 24S36.426 46.5 24 46.5S1.5 36.426 1.5 24M24 27.5a3.5 3.5 0 1 0 0-7a3.5 3.5 0 0 0 0 7M16 24a3.5 3.5 0 1 1-7 0a3.5 3.5 0 0 1 7 0m19.5 3.5a3.5 3.5 0 1 0 0-7a3.5 3.5 0 0 0 0 7\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default horizontalMenuCircleSolid
